import { Group, Stack, Text } from '@mantine/core';

import { ResourceAvatarView } from '../../../gantt/ResourceAvatar';
import type { UserCellViewProps } from './UserCell.types';

export function UserCellView({
  name,
  subtitle,
  avatarVariant = 'employee',
  photoUrl,
  avatarSize = 32,
  isConnected = false,
  connectedLabel,
  truncate = false,
}: UserCellViewProps) {
  return (
    <Group gap="sm" wrap="nowrap" style={{ minWidth: truncate ? 0 : undefined }}>
      <ResourceAvatarView
        variant={avatarVariant}
        name={name}
        photoUrl={photoUrl}
        size={avatarSize}
        isConnected={isConnected}
        connectedLabel={connectedLabel}
      />
      <Stack gap={0} style={{ minWidth: truncate ? 0 : undefined }}>
        <Text size="sm" fw={500} truncate={truncate}>
          {name}
        </Text>
        {subtitle && (
          <Text size="xs" c="dimmed" truncate={truncate}>
            {subtitle}
          </Text>
        )}
      </Stack>
    </Group>
  );
}
